import * as React from 'react';
import { MenuItem } from 'moduleBase/components/menu/MenuItem';
import { MenuBlock, MenuItem as MenuItemType, SubMenu as SubMenuType } from 'moduleBase/types/Menu';
import { FC, useState } from 'react';
import { Button, Collapse } from 'react-bootstrap';
import app from 'srcJs/App';
import SvgSprite from 'components/html-elements/SvgSprite';
import { PopoverStickOnHover } from 'components/popover/PopoverStickOnHover';
import { If, Then, Else } from 'react-if';
import { SUBMENU_ITEM_MAX_LEN_WITHOUT_TOOLTIP } from './constants';

type PropsType = {
  subMenu: SubMenuType;
  activeId?: string[] | null;
};

const SubMenu: FC<PropsType> = ({
  subMenu,
  activeId,
}) => {
  const { items } = subMenu || {};

  if (!items || !items.length) {
    return null;
  }

  const [isOpen, setIsOpen] = useState(false);
  const visibleItems = items.slice(0, 3);
  const hiddenItems = items.slice(3);

  const renderBlocks = (menuItem: MenuItemType) => {
    if (!menuItem.blocks || !menuItem.blocks.length) {
      return null;
    }

    return menuItem.blocks.map((block: MenuBlock) => (
      <div key={block.id} className="ml-16p mt-8p">
        <div className="fs-14 d-flex align-items-center">
          <SvgSprite id={block.icon} size={16} additionalClassName="mr-4p" />
          <span className="color-858585">
            {block.label}
          </span>
        </div>
        <div className="mt-8p ml-20p">
          {block.items.map((item) => (
            <MenuItem key={item.id} {...item} className="fs-14 d-flex mt-8p" activeId={activeId} />
          ))}
        </div>
      </div>
    ));
  };

  const renderVisibleMenu = () => {
    const menuItems = visibleItems.map((menuItem) => {
      const renderItem = () => (
        <div className="d-flex align-items-center w-100">
          <MenuItem
            {...menuItem}
            className={subMenu.linkClassName}
            imageClassName="mr-8p"
            imageWidth={20}
            buildNavLinkProp={subMenu.buildNavLinkProp}
            activeId={activeId}
          />
        </div>
      );
      return (
        // eslint-disable-next-line react/no-array-index-key
        <li key={menuItem.id} className={subMenu.linkHolderClassName}>
          <div className="d-flex flex-column w-100">
            <If condition={menuItem.label.length > SUBMENU_ITEM_MAX_LEN_WITHOUT_TOOLTIP}>
              <Then>
                <PopoverStickOnHover text={menuItem.label} placement="right">
                  {renderItem()}
                </PopoverStickOnHover>
              </Then>
              <Else>
                {renderItem()}
              </Else>
            </If>
            {renderBlocks(menuItem)}
          </div>
        </li>
      );
    });

    return (
      <ul className={subMenu.className}>
        {menuItems}
      </ul>
    );
  };

  const renderHiddenMenu = () => {
    if (!hiddenItems.length) {
      return null;
    }

    const menuItems = hiddenItems.map((menuItem) => {
      const renderItem = () => (
        <div className="d-flex align-items-center w-100">
          <MenuItem
            {...menuItem}
            className={subMenu.linkClassName}
            imageClassName="mr-8p"
            imageWidth={20}
            buildNavLinkProp={subMenu.buildNavLinkProp}
            activeId={activeId}
          />
        </div>
      );
      return (
        <li key={menuItem.id} className={subMenu.linkHolderClassName}>
          <If condition={menuItem.label.length > SUBMENU_ITEM_MAX_LEN_WITHOUT_TOOLTIP}>
            <Then>
              <PopoverStickOnHover text={menuItem.label} placement="right">
                {renderItem()}
              </PopoverStickOnHover>
            </Then>
            <Else>
              {renderItem()}
            </Else>
          </If>
        </li>
      );
    });

    return (
      <Collapse in={isOpen}>
        <ul className={subMenu.className}>
          {menuItems}
        </ul>
      </Collapse>
    );
  };

  const renderTrigger = () => {
    if (!hiddenItems.length) {
      return null;
    }

    return (
      <Button
        variant="link"
        className="desktop-nav-list__more"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        aria-controls="moreItems"
      >
        {isOpen
          ? app.t('base', 'hide')
          : app.t('base', '{count} more', { count: hiddenItems.length })}
      </Button>
    );
  };

  return (
    <>
      {renderVisibleMenu()}
      {renderHiddenMenu()}
      {renderTrigger()}
    </>
  );
};

export { SubMenu };
